import * as React from "react";
import { UnpublishedProductImage } from "./UnpublishedProductImage.js";
import { getProductImageUrl } from "../../../../../../mappers/server-to-client/utils/mappers/server-to-client/utils/get-product-image-url.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const UnpublishedProductImageContainer = () => {
  const {
    activeVariant: { displayName, media }
  } = useProductData();
  const imageUrl = getProductImageUrl(media);
  return /* @__PURE__ */ React.createElement(UnpublishedProductImage, { src: imageUrl, alt: displayName });
};
export {
  UnpublishedProductImageContainer
};
//# sourceMappingURL=UnpublishedProductImageContainer.js.map
